import { PersonCard } from '../Templates';

class LikeMinds {
    constructor() {
        this.lmlist = document.querySelector('.person + .page-footer .page-footer__list');
        this.loadmore = document.querySelector('.person + .page-footer .page-footer__list--link .cta');
        this.page = 1;

        this.init();
    }

    init() {
        if (this.lmlist) {
            this.events();
            this.loadnext();
        }
    }

    events() {
        this.loadmore.addEventListener('click', this.loadnext.bind(this));
    }

    loadnext() {
        const personid = this.loadmore.dataset.personid;
        const url = `/person-api/get_likeminds/${personid}/${this.page}`;

        fetch(url,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'x-requested-with': 'XMLHttpRequest'
                },
                method: 'GET',
            })
        .then(response => response.json())
        .then(data => {
            if(!data.showmore) {
                this.loadmore.style.visibility = "hidden";
            }
            this.page++;
            this.lmlist.innerHTML += this.buildLMList(data.likeminds);
        })

    }

    buildLMList(json_data) {
        return json_data.map(data => PersonCard(data)).join('');
    }
}

export default LikeMinds;
